import { withStyles } from '@material-ui/core';

import component from './component';
import styles from './styles';

export default withStyles(styles)(component);
